<template>
  <div
    class="fixed z-10 inset-0"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div
      class="flex flex-col h-screen w-full bg-white transform transition-all"
    >
      <div class="absolute right-5 top-5">
        <slot name="buttons" />
      </div>
      <div class="flex flex-1">
        <slot />
      </div>
    </div>
  </div>
</template>
